import script from "./threejs_viewer.vue?vue&type=script&setup=true&lang=js"
export * from "./threejs_viewer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__